export default {
  pageContent: [
    'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.',
    'Join us. Or at least come have fun with us.'
  ],
  positions: [
    {
       id: 0,
       title: 'Manager / Senior Manager of Customer Success',
       slug: 'customer_success_manager',
       shortDesc: 'This position will help drive value for MikMak’s customers, and scale the Customer Success practice. You’re a proven leader, highly empathetic with an analytical bent and a passion for storytelling. This position reports to the SVP of Operations.',
       description: 'MikMak is looking for a proven Customer Success leader to manage our relationships with some of the world’s leading marketers. This position includes responsibilities for Customer Success activities including on-boarding, support, analysis and strategic consultation, as well as the key outcomes of this work - ie, renewals and upsells.<br><br>A successful candidate for this role has built collaborative client relationships from the working level up to the CMO, is excited about our vision for social video, is comfortable in a dynamic startup environment, and will bring energy and passion to everything they do. This role reports to the SVP of Operations, with significant cross-functional collaboration across the entire company.',
       sections: [
         {
           heading: 'RESPONSIBILITIES',
           textContent: false,
           bullets: [
             {
               type: 'heading',
               content: 'Define and Optimize the Customer Lifecycle'
             },
             {
               type: 'bullet',
               content: 'Standardize the template for a value plan for new customers'
             },
             {
               type: 'bullet',
               content: 'Own the customer post-sale journey, and team activities and deliverables needed to support our customers at each stage of the lifecycle'
             },
             {
               type: 'bullet',
               content: 'Determine how to define, drive, and demonstrate value delivered: recommend and implement changes to client analytics and optimization processes, including team responsibilities and workflows as well as presentation materials'
             },
             {
               type: 'bullet',
               content: 'Establish escalations process, and personally manage escalations from your direct reports'
             },
             {
               type: 'bullet',
               content: 'Drive adoption of new products; initiate and close customer expansion and renewal opportunities'
             },
             {
               type: 'bullet',
               content: 'Gain customer buy-in for joint case studies and references'
             },
             {
               type: 'heading',
               content: 'Help build and develop the Customer Success team'
             },
             {
               type: 'bullet',
               content: 'Foster collaboration within team and across customer lifecycle'
             },
             {
               type: 'bullet',
               content: 'Encourage continuous learning within team, and identify opportunities to develop critical skills across the team'
             },
             {
               type: 'bullet',
               content: 'Ensure that all CSMs (and the broader MikMak team) deeply understand our customers’ businesses and objectives, and are positioned to serve as trusted advisors'
             },
             {
               type: 'heading',
               content: 'Inspire Customer Success Across Company'
             },
             {
               type: 'bullet',
               content: 'Create a company-wide culture of Customer Success, serving as the #1 advocate for our customers within MikMak'
             },
             {
               type: 'bullet',
               content: 'Inform the product roadmap based on customer input'
             },
             {
               type: 'bullet',
               content: 'Design and execute on operational and financial reporting highlighting key customer success drivers'
             },
             {
               type: 'heading',
               content: 'Own key Customer Success metrics'
             },
             {
               type: 'bullet',
               content: 'Reduced Gross Churn, increased Net Dollar Retention'
             },
             {
               type: 'bullet',
               content: 'Product adoption, customer satisfaction and NPS'
             },
             {
               type: 'bullet',
               content: 'Cultivation of referenceable clients and marketable case studies'
             },
             {
               type: 'bullet',
               content: 'Revenue through cross-sell and up-sell activity'
             }
           ]
         },
         {
           heading: 'Who you are',
           textContent: false,
           bullets: [
             {
               type: 'bullet',
               content: '3+ years building amazing customer relationships and leading CS teams in roles with progressively increasing responsibility, including significant exposure to CMOs / other senior leaders'
             },
             {
               type: 'bullet',
               content: 'A proven leader, exceptional communicator, and compelling presenter with an unbreakable resolve and excellent negotiation skills'
             },
             {
               type: 'bullet',
               content: 'Analytically savvy, familiar with ROAS and other metrics our clients are looking to optimize'
             },
             {
               type: 'bullet',
               content: 'Well-versed in all things Social and SaaS'
             },
             {
               type: 'bullet',
               content: 'Empathetic, humble and hungry'
             },
             {
               type: 'bullet',
               content: 'NYC based or ready to relocate to the best city on Earth'
             }
           ]
         },
         {
           heading: 'Benefits',
           textContent: false,
           bullets: [
             {
               type: 'bullet',
               content: 'Cash + Equity'
             },
             {
               type: 'bullet',
               content: 'Health Insurance'
             },
             {
               type: 'bullet',
               content: 'Free lunch at least once a week'
             },
             {
               type: 'bullet',
               content: 'Yearly stipend to take a class that enriches your life outside of work'
             },
             {
               type: 'bullet',
               content: 'Brooklyn loft office vibes'
             }
           ]
         },
         {
           heading: 'Who we are',
           textContent: 'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.<br><br>MikMak\'s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes\' “30 under 30 Who Are Changing The World”, Marie Claire\'s "50 Most Influential Women in America," and Fast Company\'s "Most Creative People in Business."<br><br>MikMak\'s investors include VaynerMedia, Luminari Capital, SLOW Ventures, UTA Ventures, Brave Ventures, Jeff Zucker and Christina Aguilera.',
           bullets: []
         }
       ]
     },
     {
      id: 1,
      title: 'Senior UI & UX Designer',
      slug: 'senior_designer',
      shortDesc: 'This position will lead all of Design & Research at MikMak. You have experience leading design projects large and small, and love the fast pace of a startup. This role reports to the VP of Product & Engineering.',
      description: 'MikMak is looking for an experienced, empathetic Designer to join our product team. This is an opportunity to be a foundational member of a rapidly growing company, and help define what it means to do Design and Research here.<br><br>MikMak builds commerce products that live within social platforms like Instagram, Facebook, Snapchat, and elsewhere on the web. As we expand our product portfolio and platform, we\'re looking for a Design leader to own the vision for these products.<br><br> You\'ll help establish a strong design language for our products, build out components of our growing platform, and conduct research to inform product strategy, test prototypes and measure impact.',
      sections: [
        {
          heading: 'You might be a good fit if you:',
          textContent: false,
          bullets: [
            {
              type: 'bullet',
              content: 'Have experience designing products & systems, start to finish'
            },
            {
              type: 'bullet',
              content: 'Have experience collaborating with Engineering teams'
            },
            {
              type: 'bullet',
              content: 'Have experience creating product briefs, and communicating to different teams'
            },
            {
              type: 'bullet',
              content: 'Experience with Adobe Creative Suite and Sketch is a must. Experience with tools like Figma, Invision and other prototyping tools is a big plus. '
            },
            {
              type: 'bullet',
              content: 'Have experience conducting user/usability tests'
            },
            {
              type: 'bullet',
              content: 'Can prototype ideas quickly using tools like Framer, etc'
            },
            {
              type: 'bullet',
              content: 'Have experience working in startups on projects large and small'
            },
            {
              type: 'bullet',
              content: 'Experience in eCommerce is a big plus'
            },
            {
              type: 'bullet',
              content: 'Experience with HTML/CSS/Javascript is also a plus'
            }
          ]
        },
        {
          heading: 'Benefits',
          textContent: false,
          bullets: [
            {
              type: 'bullet',
              content: 'Cash + Equity'
            },
            {
              type: 'bullet',
              content: 'Health Insurance'
            },
            {
              type: 'bullet',
              content: 'Free lunch at least once a week'
            },
            {
              type: 'bullet',
              content: 'Yearly stipend to take a class that enriches your life outside of work'
            },
            {
              type: 'bullet',
              content: 'Brooklyn loft office vibes'
            }
          ]
        },
        {
          heading: 'Who we are',
          textContent: 'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.<br><br>MikMak\'s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes\' “30 under 30 Who Are Changing The World”, Marie Claire\'s "50 Most Influential Women in America," and Fast Company\'s "Most Creative People in Business."<br><br>MikMak\'s investors include VaynerMedia, Luminari Capital, SLOW Ventures, UTA Ventures, Brave Ventures, Jeff Zucker and Christina Aguilera.',
          bullets: []
        }
      ]
    },
    {
     id: 4,
     title: 'Business Development Undergrad Intern: Summer 2018',
     slug: 'summer_intern',
     shortDesc: 'MikMak is hiring a Business Development Intern for Summer 2018! This will be a great experience for anyone interested in hands-on Business Development experience at a fast-growth startup.',
     description: 'MikMak is hiring a Business Development Intern for Summer 2018! This will be a great experience for anyone interested in hands-on Business Development experience at a fast-growth startup.',
     sections: [
       {
         heading: 'RESPONSIBILITIES',
         textContent: 'Responsibilities will span a range of special projects and core business activities, and are expected to include:',
         bullets: [
           {
             type: 'bullet',
             content: 'Create compelling visuals to include in sales materials'
           },
           {
             type: 'bullet',
             content: 'Research potential new clients and potential strategic partnerships to help identify quality leads'
           },
           {
             type: 'bullet',
             content: 'Develop case studies + content marketing in the form of 1-pagers and whitepapers highlighting 2 or 3 selected customer stories, in collaboration with our Customer Success team'
           },
           {
             type: 'bullet',
             content: 'Assist the team in all stages of the business development cycle, including but not limited to new business pitches, follow-up sales materials, social media, platform research and tracking of client pipeline'
           },
           {
             type: 'bullet',
             content: 'Additional projects as identified'
           }
         ]
       },
       {
         heading: 'Who you are',
         textContent: false,
         bullets: [
           {
             type: 'bullet',
             content: 'Current Undergraduate student'
           },
           {
             type: 'bullet',
             content: 'Savvy in making client-facing presentations and assets in Keynote, Indesign and Photoshop'
           },
           {
             type: 'bullet',
             content: 'Obsessed with building relationships as much as we are'
           },
           {
             type: 'bullet',
             content: 'Comfortable communicating in a range of situations - internal as well as client-facing'
           },
           {
             type: 'bullet',
             content: 'Empathetic, humble and hungry'
           },
           {
             type: 'bullet',
             content: 'NYC-based '
           }
         ]
       },
       {
         heading: 'Benefits',
         textContent: false,
         bullets: [
           {
             type: 'bullet',
             content: 'Free lunch at least once a week'
           },
           {
             type: 'bullet',
             content: 'Brooklyn loft office vibes'
           },
           {
             type: 'bullet',
             content: 'School credit + MTA monthly metrocard'
           }
         ]
       },
       {
         heading: 'Who we are',
         textContent: 'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.<br><br>MikMak\'s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes\' “30 under 30 Who Are Changing The World”, Marie Claire\'s "50 Most Influential Women in America," and Fast Company\'s "Most Creative People in Business."<br><br>MikMak\'s investors include VaynerMedia, Luminari Capital, SLOW Ventures, UTA Ventures, Brave Ventures, Jeff Zucker and Christina Aguilera.',
         bullets: []
       }
     ]
    },
    {
     id: 5,
     title: 'MBA Intern: Summer 2018',
     slug: 'mba_intern',
     shortDesc: 'MikMak is hiring an MBA Intern for Summer 2018! This will be a great experience for anyone interested in hands-on operations and client experience at a fast-growth startup.',
     description: 'MikMak is hiring an MBA Intern to support our rapidly growing team across Customer Success and Business Operations. ',
     sections: [
       {
         heading: 'RESPONSIBILITIES',
         textContent: 'Responsibilities will span a range of special projects and core business activities, and are expected to include:',
         bullets: [
           {
             type: 'heading',
             content: 'CUSTOMER SUCCESS'
           },
           {
             type: 'bullet',
             content: 'Customer analytics: client performance analysis/dashboards, and creation of cross-category benchmarks on a range of dimensions. Support in the creation of client-ready reports and presentations to ensure our clients are set up for success with MikMak.'
           },
           {
             type: 'bullet',
             content: 'Case studies + content marketing: create 1-pagers and whitepapers highlighting 2 or 3 selected customer stories, in collaboration with our Business Development team.'
           },
           {
             type: 'bullet',
             content: 'Additional projects as identified.'
           },
           {
             type: 'heading',
             content: 'OPERATIONS'
           },
           {
             type: 'bullet',
             content: 'Financial modeling: support in refining our financial model based on deep-dives into recent MikMak financial results as well as industry benchmarks; ad hoc analyses to support quarterly board update.'
           },
           {
             type: 'bullet',
             content: 'Revenue operations: collaborate with our BD and CS teams to help create scalable processes that improve sales performance and client responsiveness.'
           },
           {
             type: 'bullet',
             content: 'Additional projects as identified.'
           }
         ]
       },
       {
         heading: 'Who you are',
         textContent: false,
         bullets: [
           {
             type: 'bullet',
             content: 'Current MBA student'
           },
           {
             type: 'bullet',
             content: 'Experienced in telling stories from data and working collaboratively within diverse teams'
           },
           {
             type: 'bullet',
             content: 'Analytically savvy, able to get up to speed quickly on new datasets and analytical approaches'
           },
           {
             type: 'bullet',
             content: 'Comfortable communicating in a range of situations - internal as well as client-facing'
           },
           {
             type: 'bullet',
             content: 'Empathetic, humble and hungry'
           },
           {
             type: 'bullet',
             content: 'NYC based or ready to relocate to spend the summer in the best city on Earth'
           }
         ]
       },
       {
         heading: 'Benefits',
         textContent: false,
         bullets: [
           {
             type: 'bullet',
             content: 'Free lunch at least once a week'
           },
           {
             type: 'bullet',
             content: 'Brooklyn loft office vibes'
           }
         ]
       },
       {
         heading: 'Who we are',
         textContent: 'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.<br><br>MikMak\'s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes\' “30 under 30 Who Are Changing The World”, Marie Claire\'s "50 Most Influential Women in America," and Fast Company\'s "Most Creative People in Business."<br><br>MikMak\'s investors include VaynerMedia, Luminari Capital, SLOW Ventures, UTA Ventures, Brave Ventures, Jeff Zucker and Christina Aguilera.',
         bullets: []
       }
     ]
   }
  ]
}



// WEBPACK FOOTER //
// ./client/store/imports/Careers.js